/**
 * Mobile equivalent of the desktop "hover to preview second image" effect on product cards.
 * Touch has no hover, so this substitutes: briefly preview the second image each time a
 * card scrolls into view, then revert - re-triggering every time the card re-enters view.
 * Purely visual (toggles a class read by CSS); never touches click/tap navigation.
 */
(function () {
  var mql = window.matchMedia('(max-width: 989.98px)');
  var REVEAL_DELAY = 500; // avoid triggering on a fast scroll-past
  var PREVIEW_DURATION = 1500;

  var timers = new WeakMap();

  function clearTimers(card) {
    var t = timers.get(card);
    if (!t) return;
    clearTimeout(t.revealTimer);
    clearTimeout(t.hideTimer);
    timers.delete(card);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      if (entry.isIntersecting) {
        var revealTimer = setTimeout(function () {
          card.classList.add('is-previewing-secondary');
          var hideTimer = setTimeout(function () {
            card.classList.remove('is-previewing-secondary');
          }, PREVIEW_DURATION);
          timers.set(card, { revealTimer: revealTimer, hideTimer: hideTimer });
        }, REVEAL_DELAY);
        timers.set(card, { revealTimer: revealTimer, hideTimer: null });
      } else {
        clearTimers(card);
        card.classList.remove('is-previewing-secondary');
      }
    });
  }

  function init() {
    if (!mql.matches || !('IntersectionObserver' in window)) return;

    var cards = document.querySelectorAll(
      '.card-wrapper:not([data-secondary-preview-bound]) .media--hover-effect > img + img'
    );
    if (!cards.length) return;

    var observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
    cards.forEach(function (img) {
      var card = img.closest('.card-wrapper');
      if (!card || card.hasAttribute('data-secondary-preview-bound')) return;
      card.setAttribute('data-secondary-preview-bound', 'true');
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan if product cards are swapped in without a full page load (theme editor section
  // reload, or facets.js replacing #ProductGridContainer's innerHTML on filter changes).
  // init() is cheap to re-run: it skips any card already marked data-secondary-preview-bound.
  document.addEventListener('shopify:section:load', init);

  var gridObserver = new MutationObserver(function () {
    clearTimeout(gridObserver._rescan);
    gridObserver._rescan = setTimeout(init, 150);
  });
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) gridObserver.observe(grid, { childList: true, subtree: false });
  });
})();
